import React, { HTMLProps, memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './container.module.scss';
interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
    fluid?: string;
    breakpoint?: string;
}

function Container(props: IProps) {
    const { children, fluid, breakpoint, className } = props;
    return (
        <Element
            {...props}
            className={classnames(styles['container'], className, {
                [styles['is-fluid']]: fluid,
                [`is-${breakpoint}`]: breakpoint,
            })}
        >
            {children}
        </Element>
    );
}


export default memo(Container);
